/**
 * 下载远程文件为 Blob，然后以指定文件名保存
 * @param  {String} url 目标文件地址
 * @param  {String} filename 想要保存的文件名称（不含扩展名）
 */
const downLoadRemoteFile = (url, filename) => {
    fetch(url)
    .then((response) => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.blob()
    })
    .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = blobUrl
        a.download = filename + '.jpg'
        a.click()
        window.URL.revokeObjectURL(blobUrl)
    })
    .catch((error) => {
        console.error('Download failed:', error)
    })
}

export default downLoadRemoteFile;


// WEBPACK FOOTER //
// ./src/util/downLoadRemoteFile.js